import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routes = [
  {
    path: "/Login",
    component: () => import("@/views/dashboard/Login"),
  },
  {
    path: "/",
    component: () => import("@/views/dashboard/Index"),
    children: [
      {
        name: "Welcom Kinan",
        path: "",
        component: () => import("@/views/dashboard/Dashboard"),
      },
// --------------------- Products Managment -----------------------------------------------------------------
      {
        name: "B2C Category Index",
        path: "b2cCategoryIndex",
        component: () =>
          import("@/views/dashboard/modules/products-management/categories/categoriesB2cIndex"),
      },
      {
        name: "B2C Company Index",
        path: "b2cCompanyIndex",
        component: () =>
          import("@/views/dashboard/modules/products-management/companies/companyB2cIndex"),
      },
      {
        name: "B2C Material Index",
        path: "b2cMaterialsIndex",
        component: () =>
          import("@/views/dashboard/modules/products-management/materials/materialB2cIndex"),
      },
      {
        name: "B2C Reports Index",
        path: "b2cReportsProduct",
        component: () =>
          import("@/views/dashboard/modules/products-management/reports/reportsIndex"),
      },
// ---------------------- Point Of Sales Dashboard ----------------------------------------------------------
      {
        name: "point Of Sales Dashboard",
        path: "pointOfSalesDashboard",
        component: () =>
          import("@/views/dashboard/modules/point-of-sales-dashboard/PosTabs"),
      },
// ---------------------- Point Of Sales Managment ------------------------------------------------------------
      {
        name: "Sellers Groups",
        path: "salersGroupsIndex",
        component: () =>
          import("@/views/dashboard/modules/point-of-sale-management/salers-group/salersGroupsIndex"),
      },
      {
        name: "Salers Index",
        path: "salersIndex",
        component: () =>
          import("@/views/dashboard/modules/point-of-sale-management/salers/salersIndex"),
      },
      {
        name: "Sales Summary Index",
        path: "salesSummaryIndex",
        component: () =>
          import("@/views/dashboard/modules/point-of-sale-management/sales-summary/salesSummaryIndex"),
      },
// ---------------------- Orders -------------------------------------------------------------------------------
      {
        name: "Orders",
        path: "b2cOrders",
        component: () =>
          import("@/views/dashboard/modules/orders/ordersIndex"),
      },
// ---------------------- Shipping -----------------------------------------------------------------------------
      {
        name: "Shipping",
        path: "shippingIndex",
        component: () =>
          import("@/views/dashboard/modules/shipping/shippingIndex"),
      },
// ---------------------- Users --------------------------------------------------------------------------------
      {
        name: "Users Index",
        path: "usersIndex",
        component: () =>
          import("@/views/dashboard/modules/users/usersIndex"),
      },
      {
        name: "Add User",
        path: "addUser",
        component: () =>
          import("@/views/dashboard/modules/users/addUser"),
      },
      {
        name: "Edit User",
        path: "addUser/:id",
        component: () =>
          import("@/views/dashboard/modules/users/addUser"),
      },
      {
        name: "Roles Index",
        path: "rolesIndex",
        component: () =>
          import("@/views/dashboard/modules/users/rolesIndex"),
      },
      {
        name: "Add Role",
        path: "addRole",
        component: () =>
          import("@/views/dashboard/modules/users/addRole"),
      },
      {
        name: "Add Role",
        path: "addRole/:id",
        component: () =>
          import("@/views/dashboard/modules/users/addRole"),
      },
      {
        name: "Branches Index",
        path: "branchesIndex",
        component: () =>
          import("@/views/dashboard/modules/users/branchesIndex"),
      },
      {
        name: "Customers Index",
        path: "customers",
        component: () =>
          import("@/views/dashboard/modules/users/customersIndex"),
      },
// ---------------------- E-commerce Web -----------------------------------------------------------------------
      {
        name: "EcommerceHome",
        meta: { isPublic: true },
        path: "e-commerce-web",
        component: () =>
          import("@/views/dashboard/modules/website-b2c/mainApp"),
      },
      {
        name: "EcommerceProductDetail",
        meta: { isPublic: true },
        path: "e-commerce-web/product/:id",
        component: () =>
          import("@/views/dashboard/modules/website-b2c/ecommerce/views/ProductDetail"),
        props: true
      },
      {
        name: "EcommerceCart", 
        meta: { isPublic: true },
        path: "e-commerce-web/cart",
        component: () =>
          import("@/views/dashboard/modules/website-b2c/ecommerce/views/Cart"),
      },
      {
        name: "EcommerceCheckout",
        meta: { requiresAuth: true },
        path: "e-commerce-web/checkout",
        component: () =>
          import("@/views/dashboard/modules/website-b2c/ecommerce/views/Checkout"),
      },
      {
        name: "Order Index",
        path: "e-commerce-web/myOrder",
        component: () =>
          import("@/views/dashboard/modules/website-b2c/ecommerce/views/myOrders"),
      },
// ----------------------------- Invoices ------------------------------------------------------------------------------------
      {
        name: "Invoices List",
        path: "invoicesList",
        component: () =>
          import("@/views/dashboard/modules/invoices/invoicesList"),
      },
// ----------------------------- Offers ------------------------------------------------------------------------------------
      {
        name: "advertisements",
        path: "advertisementsIndex",
        component: () =>
          import("@/views/dashboard/modules/offers/advertisements/advertisementsIndex"),
      },
// --------------------------------------------------------------------------------------------------------------------------
      {
        name: "settings",
        path: "settings",
        component: () =>
          import("@/views/dashboard/modules/settings/settings"),
      },
    ],
  },
  
];

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
